import React, { Component } from 'react';
import './Contact.css';
import emailjs from "emailjs-com";
import LightSpeed from 'react-reveal/LightSpeed';
import n from './img/phone.png';
import tttt from './img2/whatsapp.png';
import possibiWhoarewe from './assets/1259.png';
import styled from 'styled-components';
import ReCAPTCHA from "react-google-recaptcha";

const Style = styled.div`
  position: relative;
`;

export default class Contact extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      contactEmail: "",
      contactMessage: "",
      captchaToken: null,
      loading: false
    };

    this.handleonChange = this.handleonChange.bind(this);
    this.sendEmail = this.sendEmail.bind(this); 
    this.captchaRef = React.createRef();
  }

  handleonChange(value) {
    this.setState({
      captchaToken: value
    });
  }
sendEmail(e) {
  e.preventDefault();

  if (this.state.loading) return;

  if (!this.state.captchaToken) {
    alert("🔒 לפני שליחת הטופס יש לאשר שאינך רובוט.");
    return;
  }

  this.setState({ loading: true });

  const form = e.currentTarget;

  emailjs
    .sendForm(
      "service_b9gmcqa",
      "template_hv6pk2g",
      form,
      "JWHOQYzsIcnM9KDko"
    )
    .then(
      (result) => {
        console.log(result.text);

        alert("הודעה נשלחה בהצלחה, ניצור קשר בהקדם!");

        form.reset();

        // 🔥 חשוב: איפוס state + captcha
        this.setState({
          captchaToken: null,
          loading: false
        });

        // 🔥 חשוב מאוד: איפוס ה-reCAPTCHA עצמו
        if (this.captchaRef) {
          this.captchaRef.reset();
        }
      },
      (error) => {
        console.log(error.text);

        alert("הודעה לא נשלחה, נסה שנית");

        this.setState({
          loading: false
        });

        // גם כאן עדיף לאפס כדי למנוע מצב תקוע
        if (this.captchaRef) {
          this.captchaRef.reset();
        }
      }
    );
}

  render() {
    return (
      <Style>

        <div
          style={{
            marginTop: "-10px",
            marginBottom: "-15px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            width: "100%",
          }}
        >

          <img src={possibiWhoarewe} alt="header" />

          <div className="wrapper">
            <div className="icon facebook">
              <div className="tooltip">התקשרו</div>
              <a href="tel:050-6831839">
                <img src={n} alt="tel" />
              </a>
            </div>

            <div className="icon twitter">
              <div className="tooltip">וואטסאפ</div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://wa.me/972506831839"
              >
                <img src={tttt} alt="whatsapp" />
              </a>
            </div>
          </div>

          <br />

          <LightSpeed right>

            <form
              onSubmit={this.sendEmail}
              style={{
                width: "100%",
                maxWidth: "600px",
                margin: "0 auto",
                background: "rgba(255,255,255,0.95)",
                padding: "40px",
                borderRadius: "30px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
              }}
            >

              <h2
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "linear-gradient(90deg,#0693e3,#001f3f)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  marginBottom: "25px",
                  fontSize: "32px",
                }}
              >
                השאירו פרטים ונחזור אליכם
              </h2>

              <input
                type="text"
                name="name"
                placeholder="שם מלא"
                required
                style={inputStyle}
              />

              <input
                type="tel"
                name="tel"
                placeholder="טלפון"
                style={inputStyle}
              />

              <textarea
                name="message"
                placeholder="איך נוכל לעזור?"
                required
                rows="6"
                style={inputStyle}
              />

         <div style={{
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
  width: "100%"
}}>
  <ReCAPTCHA
  ref={(el) => (this.captchaRef = el)}
  sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
  onChange={this.handleonChange}
  />
</div>


              <div style={{ marginTop: "25px", textAlign: "center" }}>

<button
  type="submit"
  disabled={this.state.loading || !this.state.captchaToken}
  style={{
    borderRadius: "50px",
    padding: "14px 50px",
    fontWeight: "700",
    fontSize: "18px",
    border: "none",
    color: "white",
    cursor: this.state.loading || !this.state.captchaToken ? "not-allowed" : "pointer",
    transition: "0.3s",
    boxShadow: "0 10px 30px rgba(6,147,227,0.35)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    flexDirection: "row-reverse",
    opacity: this.state.loading || !this.state.captchaToken ? 0.6 : 1,
    background:
      this.state.loading || !this.state.captchaToken
        ? "linear-gradient(90deg,#555,#888)"
        : "linear-gradient(135deg,#0693e3,#001f3f)"
  }}
>
  {this.state.loading ? (
    <>
      <span>שולח</span>
      <span className="spinner"></span>
    </>
  ) : (
    <>
      <span>שלח הודעה</span>
    </>
  )}
</button>

              </div>

            </form>

          </LightSpeed>

        </div>

      </Style>
    );
  }
}

const inputStyle = {
  width: "100%",
  textAlign: "right",
  borderRadius: "18px",
  border: "none",
  padding: "18px",
  background: "#f5f7fa",
  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
  fontSize: "16px",
  marginTop: "15px"
};














////backgroundColor:"#252f5d"


////React.render(<Contact/>, document.getElementById('app'));






////<Button   onClick={ () => { this.scrollStep();}}  className="btnbtn" variant="primary"> למעלה</Button>

///<Button  a href = 'mailto:shani.aviv.arch@gmail.com?body="Yourbody"&subject="a subject".com' className="btnbtn" variant="primary">שליחה למייל</Button>


////<Button  a href="https://wa.me/972551234567" className="btnbtn" >  <img className="im"  src={ccc} alt="3"  a href="https://wa.me/972551234567"  />&nbsp;&nbsp;שליחת הודעה</Button>




///<img className="mobile" src={c} alt="3"/> <img className="mobile" src={cc} alt="3"/>